import styled from 'styled-components'

export const s = {
  box: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: var(--theme-size-grid);
  `,
  label: styled.span`
    color: var(--theme-colors-global-general-secondary);
    font: var(--theme-typography-bodyM-regular);
    text-align: right;
  `,
  track: styled.div`
    flex: 1;
    height: var(--theme-size-grid);
    border-radius: var(--theme-borderRadius-roundedFull);
    position: relative;
    overflow: hidden;
  `,
  bg: styled.div`
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: var(--theme-colors-theme-positive-main);
  `,
  fg: styled.div`
    height: var(--theme-size-grid);
    background: var(--theme-colors-theme-brand-darker);
  `
}
